import React from "react";
import PageLayout from "../../components/layout/PageLayout";
import { useTranslation } from 'react-i18next';

export default function NotFoundPage(props) {
    const { t } = useTranslation();

    return <PageLayout title={t('title_not_found')}>
        <h1 className="text-5xl text-primary-text font-bold mb-3 mt-4">
            404
        </h1>
        <h3 className="text-2xl text-primary-text font-bold mb-3">
            {t("Page not found")}
        </h3>
    </PageLayout>;
}